import { SagaIterator } from 'redux-saga';
import { takeEvery } from 'redux-saga/effects';

import { NewMetricForDatasource } from '../actions/NewMetricForDatasourceAction';
import { handleNewMetricForDatasourceAction } from './NewMetricForDatasourceSagas';

export function* rootMetricSaga(): SagaIterator {
  yield takeEvery(NewMetricForDatasource, handleNewMetricForDatasourceAction);
}
